<div ngbDropdown class="dropdown d-inline-block">
  <a ngbDropdownToggle class="dropdown-toggle no-caret pl-2 pr-2" id="user-menu" data-bs-toggle="dropdown"
    aria-haspopup="true" aria-expanded="false" (click)="clearBoolean()">
    <i class="fa fa-user fs-4" aria-hidden="true" style="color: #00786a !important;"></i>
  </a>
  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right rounded-0 mt-3 p-0 box-shadow"
    aria-labelledby="user-menu">
    <div class="user-menu">
      <div class=" text-center p-3">
          <img src="assets/img/logoev.png" style="height: 145px;width: 279px;">
      </div>
      <br>


      <span *ngIf="global.OnboardingLoginType == 'agencyLogin'">
        <label for="userNames" class="ml-4"
          style="color: black;margin-left: 9px; font-weight: bold;">Username:&nbsp;</label>
        <label style="font-size:12px ">{{global.logginedUserName}}</label>
        <br>
        <label for="roles" class="ml-4" style="color: black;margin-left: 9px; font-weight: bold;">Role:&nbsp;</label>
        <label style="font-size:12px">{{global.globalroleName}}</label>
      </span>
      <span *ngIf="global.OnboardingLoginType == 'onboardLogin'">
        <label for="userNames" class="ms-4" style="color: black;margin-left: 9px; font-weight: bold;">Email:</label>
        <label class="ms-2"> {{OnboardUserName}}</label>
        <br>
        <label for="roles" class="ms-4" style="color: black;margin-left: 9px; font-weight: bold;">Role:&nbsp;</label>
        <label style="font-size:12px">{{global.onboardRoles}}</label>
        <br>
        <label for="roles" class="ms-4" style="color: black;margin-left: 9px; font-weight: bold;">Agency
          Name:&nbsp;</label>

        <label class="ms-4"> {{agencyName}}</label>
      </span>
      <button class="dropdown-item mt-2" (click)="routeToActiveSession()"><i
          class="fa fa-calendar mr-2"></i>&nbsp;&nbsp;Manage Session</button>
      &nbsp;&nbsp;&nbsp;&nbsp; <input type="checkbox" style="background-color: lightgray ;margin-left: -6px;;
            width: 17px" [(ngModel)]="islogoutOfAllSessions" class="mt-2" />&nbsp;Revoke All Sessions
      <button class="dropdown-item mb-1 mt-2" *ngIf="global.OnboardingLoginType == 'onboardLogin'" data-bs-toggle="modal"
      data-bs-target="#ChangePassword" ><i
        class="fa fa-password mr-2"></i>&nbsp;&nbsp;Change password</button>
      <button class="dropdown-item mb-1 mt-2" (click)="logoutSession()"><i
          class="fa fa-power-off mr-2"></i>&nbsp;&nbsp;Log
        out</button>
    </div>
  </div>
</div>


